
import React from "react";
import { cn } from "@/lib/utils";
import { Check, ChevronDown } from "lucide-react";
import { Command } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function LanguageSelect({ value, onChange }) {
  const [open, setOpen] = React.useState(false);

  const languages = [
    { code: "en", name: "English", flag: "🇬🇧" },
    { code: "ar", name: "العربية", flag: "🇸🇦" },
    { code: "so", name: "Soomaali", flag: "🇸🇴" }
  ];

  const selectedLanguage = languages.find(lang => lang.code === value) || languages[0];

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          role="combobox"
          aria-expanded={open}
          className={cn(
            "flex items-center gap-2 px-3 py-2 text-sm border rounded-md hover:bg-accent transition-colors",
            value === "ar" && "flex-row-reverse"
          )}
        >
          <span>{selectedLanguage.flag}</span>
          <span className={value === "ar" ? "font-arabic" : ""}>{selectedLanguage.name}</span>
          <ChevronDown className="w-4 h-4 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-0" align={value === "ar" ? "end" : "start"}>
        <Command>
          <div className="max-h-[300px] overflow-auto">
            {languages.map((language) => (
              <div
                key={language.code}
                className={cn(
                  "flex items-center gap-2 px-4 py-2 cursor-pointer hover:bg-accent transition-colors",
                  value === language.code && "bg-accent",
                  value === "ar" && "flex-row-reverse text-right"
                )}
                onClick={() => {
                  onChange(language.code);
                  setOpen(false);
                }}
              >
                <span>{language.flag}</span>
                <span className={language.code === "ar" ? "font-arabic" : ""}>
                  {language.name}
                </span>
                {value === language.code && (
                  <Check className={cn("w-4 h-4", value === "ar" ? "mr-auto" : "ml-auto")} />
                )}
              </div>
            ))}
          </div>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
